import { render, staticRenderFns } from "./TS-survey-duration-widget.vue?vue&type=template&id=716707e4"
import script from "./TS-survey-duration-widget.vue?vue&type=script&lang=js"
export * from "./TS-survey-duration-widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports